import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { HomeDashboard } from '@/components/home/HomeDashboard';
import { CoachGoalsCard } from '@/components/coach/CoachGoalsCard';
import { GettingStartedAchievements, useGettingStarted } from '@/components/GettingStartedCard';
import { SetupWizard } from '@/components/setup/SetupWizard';

export function Home() {
  const { slug = '' } = useParams();
  const { t } = useTranslation('common');

  const gettingStarted = useGettingStarted(slug);

  // Once core setup is done, Home stops being a welcome hero and becomes the
  // coach (docs/ai-club-coach-plan.md §4). The AI assistant itself is no
  // longer inline here — it lives in the floating bottom-right launcher
  // mounted by DashboardShell, available on every page.
  const coachMode = gettingStarted.data?.allCoreDone === true;

  if (coachMode) {
    return (
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 pb-16 pt-8 md:pt-12">
        {/* The daily command center: KPIs, upcoming week, coach to-dos, and a
            compact goal strip. Goals stay adjustable inline via the strip's edit
            button, so the ranking lens can still shift mid-season. */}
        <HomeDashboard slug={slug} />
        <GettingStartedAchievements slug={slug} />
      </div>
    );
  }

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-8 px-4 pb-16 pt-12 sm:pt-16 md:pt-24">
      <header className="flex flex-col items-center gap-2 text-center">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight md:text-5xl">
          {t('home.welcome')}
        </h1>
        <p className="max-w-xl text-sm text-muted-foreground md:text-base">
          {t('home.heroSubtitle')}
        </p>
      </header>

      <SetupWizard slug={slug} />

      {/* Season goals — the coach's ranking lens (docs/ai-club-coach-plan.md
          §3). Shown once the getting-started surface has loaded (admin), so
          goal-setting is part of onboarding rather than a buried setting. */}
      {gettingStarted.data != null && <CoachGoalsCard slug={slug} />}

      <GettingStartedAchievements slug={slug} />
    </div>
  );
}
